/**
 * ENTRAR — e-mail e senha, «Esqueci minha senha», e a tela que abre pelo link
 * do e-mail (convite ou senha nova).
 */
import { useEffect, useState, type FormEvent } from 'react'
import { api, conferirSessao, entrar, entrouDeNovo, Recusa, SemSinal } from '../dados/sessao'
import { Campo, Dica, Tarja } from '../ui'

function mensagemDe(e: unknown): string {
  if (e instanceof SemSinal) return 'Sem internet agora. O primeiro acesso precisa de sinal; depois o app abre sem.'
  if (e instanceof Recusa) return e.message
  return 'Não deu para concluir. Tente de novo.'
}

export function Entrar() {
  const [modo, setModo] = useState<'entrar' | 'esqueci'>('entrar')
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [indo, setIndo] = useState(false)

  async function enviarLogin(e: FormEvent) {
    e.preventDefault()
    setErro(''); setIndo(true)
    try { await entrar(email, senha) } catch (x) { setErro(mensagemDe(x)) } finally { setIndo(false) }
  }
  async function enviarEsqueci(e: FormEvent) {
    e.preventDefault()
    setErro(''); setAviso(''); setIndo(true)
    try {
      const r = await api<{ mensagem: string }>('esqueci', { email })
      setAviso(r.mensagem)
    } catch (x) { setErro(mensagemDe(x)) } finally { setIndo(false) }
  }

  return (
    <div className="tela-entrada">
      <h1>Pesagem</h1>
      <div className="mini-dica" style={{ marginBottom: 16 }}>Gado no curral, romaneio e agenda</div>
      {modo === 'entrar' ? (
        <form className="cartao" onSubmit={enviarLogin}>
          <Campo rotulo="E-mail" tipo="email" valor={email} mudar={setEmail} />
          <Campo rotulo="Senha" tipo="password" valor={senha} mudar={setSenha} />
          {erro && <div className="alerta">{erro}</div>}
          <button className="botao grande" disabled={indo}>{indo ? 'Entrando…' : 'Entrar'}</button>
          <button type="button" className="botao fantasma pequeno" onClick={() => { setModo('esqueci'); setErro('') }}>Esqueci minha senha</button>
        </form>
      ) : (
        <form className="cartao" onSubmit={enviarEsqueci}>
          <Dica>Digite o seu e-mail. Mandamos um link para você criar uma senha nova. O link vale 30 minutos.</Dica>
          <Campo rotulo="E-mail" tipo="email" valor={email} mudar={setEmail} />
          {erro && <div className="alerta">{erro}</div>}
          {aviso && <Tarja tipo="ok">{aviso}</Tarja>}
          <button className="botao grande" disabled={indo}>{indo ? 'Enviando…' : 'Mandar o link'}</button>
          <button type="button" className="botao fantasma pequeno" onClick={() => { setModo('entrar'); setErro(''); setAviso('') }}>Voltar para entrar</button>
        </form>
      )}
    </div>
  )
}

/** Tela aberta pelo link do e-mail: ?acesso=TOKEN */
export function CriarSenha({ token, pronto }: { token: string; pronto: () => void }) {
  const [info, setInfo] = useState<{ tipo: string; nome: string; email: string; conta: string } | null>(null)
  const [erroLink, setErroLink] = useState('')
  const [senha, setSenha] = useState('')
  const [repete, setRepete] = useState('')
  const [erro, setErro] = useState('')
  const [indo, setIndo] = useState(false)

  useEffect(() => {
    api<{ tipo: string; nome: string; email: string; conta: string }>(`link?t=${encodeURIComponent(token)}`)
      .then(setInfo)
      .catch((e) => setErroLink(mensagemDe(e)))
  }, [token])

  async function enviar(e: FormEvent) {
    e.preventDefault()
    setErro('')
    if (senha !== repete) { setErro('As duas senhas não são iguais.'); return }
    setIndo(true)
    try {
      await api('definir-senha', { token, senha })
      entrouDeNovo()
      await conferirSessao()
      pronto()
    } catch (x) { setErro(mensagemDe(x)) } finally { setIndo(false) }
  }

  return (
    <div className="tela-entrada">
      <h1>Pesagem</h1>
      {erroLink ? (
        <div className="cartao">
          <Tarja tipo="erro">{erroLink}</Tarja>
          <button className="botao" onClick={pronto}>Ir para a tela de entrar</button>
        </div>
      ) : !info ? (
        <div className="cartao vazio">Conferindo o link…</div>
      ) : (
        <form className="cartao" onSubmit={enviar}>
          <div className="nome">Olá, {info.nome}</div>
          <div className="mini-dica">{info.tipo === 'convite' ? `Equipe de ${info.conta}. Crie a sua senha para começar.` : 'Escolha a sua senha nova.'}</div>
          <div className="mini-dica">Seu login é o e-mail <b>{info.email}</b>.</div>
          <Campo rotulo="Senha (4 ou mais — pode ser só números)" tipo="password" valor={senha} mudar={setSenha} />
          <Campo rotulo="Repita a senha" tipo="password" valor={repete} mudar={setRepete} />
          {erro && <div className="alerta">{erro}</div>}
          <button className="botao grande" disabled={indo}>{indo ? 'Salvando…' : 'Salvar senha e entrar'}</button>
          <Dica>Se esquecer, é só usar «Esqueci minha senha» na tela de entrar: o link chega no seu e-mail.</Dica>
        </form>
      )}
    </div>
  )
}
